import { useAnalytics, useRequestUrl } from "../hooks";

import { TwitterIcon } from "./icons";
import { GenericShareButton, InnerShareButton } from "./social-sharing.styles";

export type TwitterShareButtonProps = {
    readonly block?: boolean;
    readonly buttonColor?: string;
    readonly buttonText?: string;
    readonly buttonTextColor?: string;
    readonly hashtags?: readonly string[];
    readonly iconColor?: string;
    readonly message: string;
    readonly shareUrl?: string;
    readonly uuid: string;
    readonly type: string;
};

export const TwitterShareButton = ({
    block = false,
    buttonColor = "#1DA1F2", //twitter brand blue
    buttonText = "Twitter",
    buttonTextColor = "white",
    hashtags = [],
    iconColor = "white",
    message,
    shareUrl,
    uuid,
    type
}: TwitterShareButtonProps) => {
    const { sendTrackEvent } = useAnalytics();
    const requestUrl = useRequestUrl();
    const params = {
        text: message,
        url: shareUrl || requestUrl,
        related: "trello"
    };
    const queryString = new URLSearchParams(
        hashtags.length
            ? {
                  ...params,
                  hashtags: hashtags
                      .map((hashtag) => hashtag.replace("#", ""))
                      .join(",")
              }
            : params
    );
    const url = `https://twitter.com/intent/tweet?${queryString}`;
    return (
        <GenericShareButton
            $block={block}
            $buttonColor={buttonColor}
            $colorOverride={buttonTextColor}
            href={url}
            title="Twitter"
            onClick={() =>
                sendTrackEvent("clickedAnchor", {
                    event: "clicked",
                    eventComponent: "button",
                    eventContainer: type,
                    label: buttonText,
                    labelEnglish: "Twitter",
                    uuid: `${uuid}_twitterButton`,
                    href: url
                })
            }
            data-uuid={`${uuid}_twitterButton`}
        >
            <InnerShareButton>
                <TwitterIcon color={iconColor} />
                <span>{buttonText}</span>
            </InnerShareButton>
        </GenericShareButton>
    );
};
